export default "__VITE_ASSET__DAPb92aB__"